import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import localStorageAccessor from "@utility/local-storage-accessor";
import { PermissionChecker } from "@utility/permission-checker";
import UnAuthorizedPage from "@ui/pages/unauthorized-page";
import userService from "@utility/user-service";
export const ProtectedRoute = ({ requiredPermissions, requireAll = false, allowSuperAdmin = false, requireSuperAdmin = false, }) => {
    const token = localStorageAccessor.getAccessToken();
    const user = localStorageAccessor.getUser();
    if (!token || !user) {
        return React.createElement(Navigate, { to: "/insight/login", replace: true });
    }
    if (requireSuperAdmin && !userService.hasRole("Super Admin")) {
        return (React.createElement(UnAuthorizedPage, { message: "You don't have permission to access this page" }));
    }
    if (requiredPermissions && requiredPermissions.length > 0) {
        const hasPermissionAccess = requireAll
            ? PermissionChecker.hasAllPermissions(requiredPermissions)
            : PermissionChecker.hasAnyPermission(requiredPermissions);
        const hasAccess = hasPermissionAccess ||
            (allowSuperAdmin && userService.hasRole("Super Admin"));
        if (!hasAccess) {
            // Enhanced debug logging in development
            if (process.env.NODE_ENV === 'development') {
                const userPermissions = PermissionChecker.getAllPermissions();
                const normalizedRequired = requiredPermissions.map(p => String(p).trim());
                console.error('ProtectedRoute - Access Denied:', {
                    path: window.location.pathname,
                    requiredPermissions: normalizedRequired,
                    userPermissions: userPermissions,
                    user: user ? {
                        id: user.id,
                        email: user.email,
                        permissions: user.permissions
                    } : null,
                    requireAll,
                    hasDashboardView: userPermissions.includes('Dashboard.View'),
                    hasAccessPointsView: userPermissions.includes('AccessPoints.View'),
                    checkResult: normalizedRequired.some(req => userPermissions.includes(req)),
                });
            }
            return (React.createElement(UnAuthorizedPage, { message: "You don't have permission to access this page" }));
        }
    }
    return React.createElement(Outlet, null);
};
export default ProtectedRoute;
